import create, { UseStore } from 'zustand';
import useScript from './dom';
import { Alert, CodeSet } from './domain';
import { refreshFetch } from './refresh-fetch';
import { authHeader, AysncFn, FetchRequestProps } from './';
import { HcpcsResult } from './trucode-domain';
import React from 'react';
// https://wsstage.trucode.com
// https://ws.trucode.com

const client_id = 'presidiohealth';
const client_secret =
  '00d5fb441ef62f37975ba8bc7cea205482a2ceb130c04fd04946ed8e0ea81e935560c948a06c6e531c6f83aab8be543654641edc07e99d9b6aec7e79c9732784';
const customer_id = 'Test';
const grant_type = 'client_credentials';
const user_id = 'tod.antilla@presidiohealth.com';

type AuthResponse = {
  access_token: string;
  expires_in: number;
  token_type: 'Bearer';
};

export async function trueCodeAuth(): Promise<AuthResponse> {
  const url = `https://wsstage.trucode.com/STS/oauth2/token`;
  const body = new URLSearchParams(
    `grant_type=${grant_type}&client_id=${client_id}&client_secret=${client_secret}&customer_id=${customer_id}&user_id=${user_id}`
  );

  try {
    const response: Response = await fetch(url, {
      body,
      method: 'POST',
      headers: {
        Host: 'ws.trucode.com',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return Promise.resolve(response.json());
  } catch (error) {
    console.error('Tru Code Auth', error);
    return Promise.reject(error);
  }
}

const tcKey = 'tc-token';
function getTcToken(): string {
  return localStorage.getItem(tcKey);
}
function setTcToken(token: string) {
  return localStorage.setItem(tcKey, token);
}

export const refreshTcToken = async () => {
  const response: AuthResponse = await trueCodeAuth();
  setTcToken(response.access_token);
  return Promise.resolve();
};

export function trueCodeRequest<T = any, U = any>(
  props: FetchRequestProps<T>
): AysncFn<T, U> {
  const { url, method, body } = props;

  return (args?: T) => {
    return refreshFetch({
      refreshToken: refreshTcToken,
      fetch: async () => {
        if (!getTcToken()) {
          await refreshTcToken();
        }
        return fetch(
          url(args),
          authHeader(getTcToken(), {
            method,
            body: body ? JSON.stringify(body(args)) : null,
          })
        );
      },
    })();
  };
}

type Id = {
  id: string;
};
export const getArticleRequest = trueCodeRequest<Id, any>({
  method: 'GET',
  url: (args: Id) =>
    `https://wsstage.trucode.com/v3/References/GetArticle?id=${args.id}&partial=false`,
});

export const getResourceRequest = trueCodeRequest<Id, any>({
  method: 'GET',
  url: (args: Id) =>
    `https://wsstage.trucode.com/v3/References/GetResource?id=${args.id}`,
});

// https://ws.trucode.com/v3/References/GetResource?id=PDF_I10_PCS_REFERENCE_MANUAL&access_token=...

// https://ws.trucode.com/v3/MedicalNecessityEdits/Calculate

type EditArgs = {
  cpt?: string;
  dx?: string;
};
export const medicalEditsRequest = trueCodeRequest<EditArgs, HcpcsResult>({
  method: 'POST',
  body: (args: EditArgs) => {
    const diagnosis = (args?.dx || '')
      .split(' ')
      .map((v) => ({ code: v.trim() }));

    return {
      medical_necessity_edits_input: {
        diagnoses: {
          diagnosis,
        },
        hcpcs_procedures: {
          hcpcs_procedure: [
            {
              code: args?.cpt || '',
              date: '2020-01-01',
            },
          ],
        },
        // TODO pass patient data
        // age_in_years:50,
        // sex:2,
        mac: 15,
        options: {
          coding_system: 'ICD10',
          frequency_edits: true,
          include_informational_articles: true,
          description: true,
        },
      },
    };
  },
  url: () => 'https://wsstage.trucode.com/v3/MedicalNecessityEdits/Calculate',
});

type TruCodeProps = {
  trueCodeReady: (api: any) => void;
};

type Trucode = any & {
  $: any;
};
let truCodeJs: Trucode = null;

export function useTrueCode(props: TruCodeProps) {
  const { trueCodeReady } = props;
  const host: any = window;

  if (!host.TC) {
    host.TC = {
      env: 'stage',
      authorizationKey: 'EXPIRINGKEY',
      settings: { templates: {} },
      authorizationExpired: ($: any) => {
        truCodeJs.$ = $;

        const dfd = new $.Deferred();
        trueCodeAuth().then((auth) => {
          dfd.resolve(auth.access_token);
        });
        return dfd.promise();
      },
      ready: function (truCode: any) {
        truCodeJs = truCode;
        trueCodeReady(truCodeJs);
      },
    };
  }

  useScript({
    src: './trucode/trucode.all.js',
    checkForExisting: true,
    id: 'tc-api',
    complete: () => {},
  });
}

export type TruCodePost = Partial<CodeSet>;

export type TruCodePostEvent = {
  codes: TruCodePost[];
};

export type TruCodeEvents = {
  onCodePosted?: (e: TruCodePostEvent) => void;
};

/*
switch (bookVal) {
                    case 'ICD9CM_DX':
                    case 'ICD9CM_E':
                    case 'ICD9CM_PR':
                    case 'ICD10CM_DX':
                    case 'ICD10CM_E':
                    case 'ICD10PCS_PR':
                        this.$('.use-anesthesia').hide();
                        this.$('.find-all').show();
                        this.$('.show-modifiers').hide();
                        break;
                    case 'CPT4_TABULAR':
                    case 'CPT4':
                        this.$('.use-anesthesia').show();
                        this.$('.find-all').hide();
                        this.$('.show-modifiers').show();
                        break;
                    case 'HCPCS_TABULAR':
                    case 'HCPCS':
                        this.$('.use-anesthesia').hide();
                        this.$('.find-all').hide();
                        this.$('.show-modifiers').show();
                        break;
                    default:
                        this.$('.use-anesthesia').hide();
                        this.$('.find-all').hide();
                        this.$('.show-modifiers').hide();
                        break;
                }
*/
type BookFilter = 'ICD10CM_DX' | 'CPT4' | 'HCPCS';
export const defaultBookFilter: BookFilter = 'ICD10CM_DX';

export function filterForCodeset(c: CodeSet, defaultFilter = defaultBookFilter): BookFilter {
  if (!c) {
    return defaultFilter;
  }
  switch (c.codeType) {
    case 'PROC_CPT':
      return 'CPT4';
    case 'ICD_10':
      return 'ICD10CM_DX';
    case 'MOD_HCPCS':
      return 'HCPCS';
    default:
      return defaultFilter;
  }
}

type TruCodeParams = {
  query?: string;
  filter?: BookFilter;
  events?: TruCodeEvents;
  serviceDate?: string;
};

export type TruCodeApi = {
  alert: Alert;
  truCode: any;
  codes: TruCodePost[];
  open: boolean;
  params?: TruCodeParams;
  setCodes(v: TruCodePost[]): void;
  openCodeBooks(params: TruCodeParams): void;
  setSearch(search: string): void;
  closeWindow(): void;
};

const codeBooksEventChannel = new window.BroadcastChannel(
  'codeBooksEventChannel'
);
const paramKey = 'truCodeParams';

export function getCodeBookParams(): TruCodeParams {
  return JSON.parse(localStorage.getItem(paramKey));
}
export function setCodeBookParams(params: TruCodeParams): void {
  localStorage.setItem(
    paramKey,
    JSON.stringify({
      query: params.query,
      filter: params.filter,
      serviceDate: params.serviceDate,
    })
  );
}

function truCodeApi(): UseStore<TruCodeApi> {
  let events: TruCodeEvents = null;
  let w: Window;

  function openWindow(): Window {
    const windowFeatures = `menubar=no,location=yes,resizable=yes,scrollbars=yes,status=no,
        width=${Math.floor(window.innerWidth * 0.8)}px,height=${Math.floor(
      window.innerHeight * 1
    )}px`;
    w = window.open('/search', 'Tru Code Search', windowFeatures);
    if (w) {
      w.addEventListener('beforeunload', (e) => {
        // TODO window close strategy
        // https://stackoverflow.com/questions/24081699/why-onbeforeunload-event-is-not-firing/24081747
        // prevent duplicate windows
        // console.log('window closed', e);
        api.setState({ open: false });
      });
    }
    return w;
  }

  function closeWindow() {
    if (w) {
      w.close();
      api.setState({ open: false });
    }
  }
  codeBooksEventChannel.onmessage = (e) => {
    if (events && events.onCodePosted) {
      events.onCodePosted(e.data);
    }
  };

  function setSearch(search: string) {
    const doc = window?.document;
    if (doc) {
      const el: HTMLInputElement = doc.getElementsByClassName(
        'search-box'
      )[0] as any;
      //  console.log('setSearch', el)
      if (el) {
        el.value = search;
      }
    }
  }

  const api = create<TruCodeApi>((set) => ({
    alert: null,
    truCode: null,
    codes: null,
    params: null,
    open: false,
    setSearch,
    closeWindow,
    setCodes: (codes: TruCodePost[]) => {
      set({ codes });
      codeBooksEventChannel.postMessage({ codes });
    },
    openCodeBooks: (params: TruCodeParams) => {
      set({ params, open: true });

      if (params) {
        setCodeBookParams(params);
      }

      if (params.events) {
        events = params.events;
      }

      openWindow();
    },
  }));
  return api;
}

export const truCode = truCodeApi();

export function TruCode() {
  useTrueCode({
    trueCodeReady: (api: any) => {
      truCodeJs = api;
      truCode.setState({ truCode: api });
      (window as any).truCodeApi = api;
    },
  });
  return <></>;
}
